// extracted by mini-css-extract-plugin
export default {"activeMarkets__empty":"styles_activeMarkets__empty__Nm+S4","activeMarkets__list":"styles_activeMarkets__list__Glxhg"};